module.exports = "<button class=\"btn btn-danger\" (click)=\"pedirConfirmacion()\">\r\n {{'DESHABILITACION' | i18next}}\r\n</button>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/deleteEntity/deleteEntity.component.html
// module id = ../../../../../src/app/helpers/components/deleteEntity/deleteEntity.component.html
// module chunks = main